import { TextField } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import Report from "../Report";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function BalanceHistoryByAgent() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agent, setAgent] = useState("");
  const onAgentChange = useCallback(
    (event) => setAgent(event.target.value),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent"
          type="text"
          value={agent}
          size="small"
          onChange={onAgentChange}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        title="Balance History By Agent Report"
        getUrl={() => "/Reports/Report_Balance_History_ByAgent"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Agent: agent,
        })}
        getTotals={(data) => ({
          startDate: "Totals",
          thisWeek: data.reduce((acc, item) => acc + item.thisWeek, 0),
          pmts: data.reduce((acc, item) => acc + item.pmts, 0),
          day1: data.reduce((acc, item) => acc + item.day1, 0),
          day2: data.reduce((acc, item) => acc + item.day2, 0),
          day3: data.reduce((acc, item) => acc + item.day3, 0),
          day4: data.reduce((acc, item) => acc + item.day4, 0),
          day5: data.reduce((acc, item) => acc + item.day5, 0),
          day6: data.reduce((acc, item) => acc + item.day6, 0),
          day7: data.reduce((acc, item) => acc + item.day7, 0),
          settled: data.reduce((acc, item) => acc + item.settled, 0),
          countPlayers: data.reduce((acc, item) => acc + item.countPlayers, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="startDate"
          dataFormat={dateReportFormatter}
        >
          Week
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="countPlayers">
          Players
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="thisWeek">
          This Week
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="pmts">
          Pmts
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="description">
          Description/Reference
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day1"
          dataFormat={decimalInvertedReportFormatter}
        >
          Mon
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day2"
          dataFormat={decimalInvertedReportFormatter}
        >
          Tue
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day3"
          dataFormat={decimalInvertedReportFormatter}
        >
          Wed
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day4"
          dataFormat={decimalInvertedReportFormatter}
        >
          Thu
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day5"
          dataFormat={decimalInvertedReportFormatter}
        >
          Fri
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day6"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sat
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day7"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sun
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default BalanceHistoryByAgent;
